import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AudioProvider, useAudio } from "@/contexts/AudioContext";
import { PomodoroProvider } from "@/contexts/PomodoroContext";
import { YouTubeRadio } from "@/components/YouTubeRadio";
import Index from "./pages/Index";
import About from "./pages/About";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Global YouTube Radio that persists across routes
const GlobalYouTubeRadio = () => {
  const { isPlaying, musicVolume, setMusicVolume } = useAudio();
  
  return (
    <div className="absolute w-px h-px -m-px overflow-hidden opacity-0 pointer-events-none -z-50" aria-hidden>
      <YouTubeRadio 
        volume={musicVolume} 
        onVolumeChange={setMusicVolume}
        autoPlay={isPlaying}
      />
    </div>
  );
};

const AppContent = () => (
  <>
    <GlobalYouTubeRadio />
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/admin" element={<Admin />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AudioProvider>
        <PomodoroProvider>
          <AppContent />
        </PomodoroProvider>
      </AudioProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
